/** Support (P9): help page (answers first, then a ticket), ticket thread; admin queue, notes, templates, knowledge base. */
export default {
  nav: "Help",
  title: "Help and support",
  lead: "Search the answers first. If yours is not there, write to us and the reply comes here.",
  search: "Search answers",
  searchPlaceholder: "e.g. daily loss, payout, fill",
  noAnswers: "No answers match. Try other words, or ask us below.",
  notFound: "Didn't find your answer?",
  contact: "Contact support",
  categories: { account: "Account and rules", trading: "Trading and fills", payments: "Payments and payouts", kyc: "Identity check", technical: "Technical problem", other: "Something else" },
  form: {
    title: "New request",
    category: "Topic",
    pickTopic: "Pick a topic",
    account: "Account (optional)",
    noAccount: "Not about a specific account",
    subject: "Subject",
    subjectHint: "One line, e.g. «Order filled at a different price»",
    body: "What happened?",
    bodyHint: "Include the time, the instrument and what you expected. One request per problem.",
    send: "Send request",
    cancel: "Cancel",
  },
  my: "My requests",
  none: "You have no requests yet.",
  status: { open: "Waiting for support", pending_staff: "Waiting for support", pending_user: "Waiting for your reply", resolved: "Resolved", closed: "Closed" },
  thread: {
    back: "All requests",
    you: "You",
    support: "Support",
    reply: "Your reply",
    send: "Send",
    close: "Close request",
    closed: "This request is closed. Open a new one if you need more help.",
    resolvedHint: "We think this is solved. Reply if it is not, and the request reopens.",
  },
  admin: {
    tab: "Support",
    views: { queue: "Queue", kb: "Knowledge base", templates: "Templates" },
    filter: { active: "Needs us", waiting: "Waiting on customer", resolved: "Resolved", closed: "Closed", all: "All" },
    anyCategory: "Any topic",
    anyone: "Anyone",
    mine: "Assigned to me",
    unassigned: "Unassigned",
    empty: "Nothing here. The queue is clear.",
    ticket: "Request",
    topic: "Topic",
    statusCol: "Status",
    priorityCol: "Priority",
    due: "First answer due",
    overdue: "overdue",
    assignee: "Assignee",
    status: { open: "New", pending_staff: "Customer replied", pending_user: "Waiting on customer", resolved: "Resolved", closed: "Closed" },
    priority: { low: "Low", normal: "Normal", high: "High", urgent: "Urgent" },
    pick: "Pick a request from the queue.",
    account: "Account",
    language: "Language",
    internal: "Internal note",
    template: "Insert a template",
    message: "Message",
    noteMode: "Internal note (the customer does not see it)",
    andResolve: "Mark resolved",
    sendReply: "Send reply",
    addNote: "Add note",
    kb: {
      new: "New article",
      slug: "Slug (same for every language)",
      locale: "Language",
      category: "Topic",
      title: "Title",
      body: "Text",
      sort: "Order",
      published: "Published",
      draft: "Draft",
      save: "Save",
      delete: "Delete",
      saved: "Saved.",
      confirmDelete: "Delete for good?",
    },
    tpl: {
      new: "New template",
      title: "Title",
      body: "Text ({name} becomes the customer's name)",
      category: "Topic",
      anyTopic: "Any topic",
      locale: "Language",
    },
  },
} as const;
